var map = {
	"./activity.svg": 120,
	"./alert-circle.svg": 3300,
	"./arrow-toggle.svg": 9495,
	"./bin-outline.svg": 2735,
	"./bin.svg": 4734,
	"./check.svg": 1513,
	"./cross.svg": 4957,
	"./error.svg": 3943,
	"./handle.svg": 1973,
	"./home.svg": 3942,
	"./loader.svg": 4034,
	"./login.svg": 4138,
	"./menus.svg": 1685,
	"./plus.svg": 2435,
	"./settings.svg": 8964,
	"./users.svg": 4189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1440;